import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_URL_FOTO_A_ELIMINAR } from '../../../actions/actionTypes';

const ESTAT_INICIAL = '';

const urlFotoAEliminar = (state = ESTAT_INICIAL, action) => {

    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;
        case AVIS_INTRODUCCIO_MODIFICAR_URL_FOTO_A_ELIMINAR:
            return action.urlFotoAEliminar;
        default:
            return state;
    }
};

export default urlFotoAEliminar;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/urlFotoAEliminar.js